export default __webpack_public_path__ + "static/media/avatar-2.0168c886.png";